module.exports = __webpack_public_path__ + "static/fonts/Fact-CondensedThin.8c42d56.woff";